import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingAdvantages4 = props => (
    <section id="outsourcing-advantages-section4" className="my pt-5 blue-bg">
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingAdvantages:section-4.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingAdvantages:section-4.text"
                    components={{
                        br: <br />,
                        outsourcingVsFull: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_vs_full.path')} className="link" />,
                        outsourcingCost: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_cost.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingAdvantages4;
